import { COUNTRY_CODE_ES } from 'commonsConstants/countryCodes';
import { mustIncludeJoinDecisionLikeRequiredField } from 'utilities/logicByCountry';
import { TRADITIONAL } from 'constants/userProfile';
import { FIXED_PAYMENT_METHOD_VALUE, VARIABLE_PAYMENT_METHOD_VALUE } from 'utilities/paymentMethodHelper';
import { doTagValidateFields, doTagCompleteYourDataIncorrect, doTagFieldsWithError } from '../tagging';

export const useFieldsValidation = ({
    docNumberEncrypted,
    focusActions,
    formActions,
    formValidations,
    immStepsState,
    scorings,
    userProfile,
}) => {
    const {
        birthCountry,
        // eslint-disable-next-line camelcase
        creditCardOffer_accepted,
        investmentType,
        isJointHolder,
        jointHolder,
        paymentMethodType,
        recordId,
    } = userProfile;

    const getJointHolderFields = () => {
        if (typeof jointHolder === 'undefined' || jointHolder.length === 0) return [];

        return jointHolder.flatMap(holder => [
            `jointHolder_name_${holder}`,
            `jointHolder_lastName_${holder}`,
            `jointHolder_secondLastName_${holder}`,
            `jointHolder_email_${holder}`,
        ]);
    };

    const getAdditionalFields = () => {
        const fields = [];

        const ML2 = scorings?.getIn(['ml2', 'scoringStatus']) === 'approved' ?? false;

        if (mustIncludeJoinDecisionLikeRequiredField() && !isJointHolder && investmentType === TRADITIONAL) {
            fields.push('jointHolderDecision');
        }

        if (birthCountry === COUNTRY_CODE_ES) {
            fields.push('birthProvince');
        }

        fields.push(...formValidations.firstAddress);
        fields.push(...getJointHolderFields());

        // eslint-disable-next-line camelcase
        if (creditCardOffer_accepted && ML2) {
            fields.push('paymentMethodType');

            if (paymentMethodType === FIXED_PAYMENT_METHOD_VALUE) {
                fields.push('fixedPaymentMethodValue');
            } else if (paymentMethodType === VARIABLE_PAYMENT_METHOD_VALUE) {
                fields.push('variablePaymentMethodValue');
            }
        }

        return fields;
    };

    const getRequiredFields = () => {
        const baseFields = formValidations.primaries;

        return [...baseFields, ...getAdditionalFields()];
    };

    const validateRequiredFields = requiredFields =>
        requiredFields.reduce((acc, requiredField) => {
            const field = userProfile[requiredField];
            if (typeof field === 'undefined' || field === '') {
                formActions.setValidity(`userProfile.${requiredField}`, { required: false });

                return [...acc, requiredField];
            }

            return acc;
        }, []);

    const handleValidationErrors = fieldsWithError => {
        const fieldsWithErrorString = fieldsWithError.join('|');
        doTagFieldsWithError({ fieldsWithError: fieldsWithErrorString, investmentType });
        doTagCompleteYourDataIncorrect({ docNumberEncrypted, investmentType, recordId });
    };

    const setFormValidity = valid => {
        formActions.setValidity('userProfile', { valid });
    };

    const isFormReadOnly = () => {
        return immStepsState.get('readOnlyForms');
    };

    const onHandleValidateFields = () => {
        doTagValidateFields();
        focusActions.triggerValidations(true);

        if (isFormReadOnly()) {
            setFormValidity(true);

            return true;
        }

        const requiredFields = getRequiredFields();
        const fieldsWithError = validateRequiredFields(requiredFields);

        if (fieldsWithError.length > 0) {
            handleValidationErrors(fieldsWithError);

            return false;
        }

        setFormValidity(true);

        return true;
    };

    return { onHandleValidateFields };
};
